import { root } from '@/infrastructure/container';
import type { Token } from '@/infrastructure/container';

// The only DI touch a view gets: resolve its ViewModel and bind. No hooks for app state.
export function useResolve<T>(tok: Token<T>): T {
  return root.resolve(tok);
}
